// extracted by mini-css-extract-plugin
export var productImage = "_mw-1";
export var viewLink = "_mw-2";
export var wishlistItem = "_mw-0";